export const servicesConfig = {
  uae: {
    services: [
      {
        icon: "dry.png",
        id: "dry_cleaning"
      },
      {
        icon: "premiumlaundry_icon.png",
        id: "premium_laundry"
      },
      {
        icon: "washfold_icon.png",
        id: "wash_fold"
      },
      {
        icon: "iron.png",
        id: "steam_press"
      },
      {
        icon: "shoecleaning_icon.png",
        id: "shoe_cleaning"
      }
    ]
  }
};